/**
 * Checks if the status of the object matches that of the target given.
 */
const checkStatus = (obj, target) => {
  if (!obj) return false;
  if (typeof obj === 'string') return obj === target;
  let targetStatus = target;

  if (typeof target === 'object') {
    targetStatus = typeof target.status === 'string' ? target.status : target.status.status;
  }

  return typeof obj.status === 'string' ? obj.status === targetStatus : obj.status.status === targetStatus;
};
/**
 * Checks if the status of the object matches any of the statuses given.
 */


const checkStatuses = (obj, statusesToCheck) => {
  if (!obj || !statusesToCheck.length) return false;

  if (typeof obj === 'string') {
    return statusesToCheck.includes(obj);
  }

  return typeof obj.status === 'string' ? statusesToCheck.includes(obj.status) : statusesToCheck.includes(obj.status.status);
};
/**
 * Checks if the status of the first argument matches that of the status(es) of the second argument.
 */


const hasStatus = (obj, statusesToCheck) => {
  if (!obj || !statusesToCheck) return false;
  if (Array.isArray(statusesToCheck)) return checkStatuses(obj, statusesToCheck);
  return checkStatus(obj, statusesToCheck);
};

export { hasStatus };
